<script setup lang="ts">
import { toRefs } from "vue";

const props = defineProps({
  color: {
    type: String,
    default: "#707072",
  },
  hoverColor: {
    type: String,
    default: "#acacac",
  },
  size: {
    type: String,
    default: "16px",
  },
});
const { color, hoverColor, size } = toRefs(props);
</script>

<template>
  <div absolute r-15 t-15 lead-1 z-1>
    <div
      class="iconfont ppt-close normal text-12"
      p-6
      rounded-4
      cursor-pointer
    ></div>
  </div>
</template>

<style lang="scss">
.normal {
  font-size: v-bind(size);
  color: v-bind(color);
  &:hover {
    background-color: v-bind(hoverColor);
  }
}
</style>
